export default __webpack_public_path__ + "static/media/icon-publish.4800ad4b.svg";